import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-related-proposed-asus',
  templateUrl: './help-related-proposed-asus.component.html'
})
export class HelpRelatedProposedAsusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
